<div >
    <div class="edit-button-style section-title" (click)="editPoolPoints()">
        <img alt="edit" src="/assets/img/edit-icon.svg"> Edit
    </div>
    
    <snl-side-panel panelType="close" [headerName]="headerName" size="large" [(isOpen)]="openEditPoolPoints">
        <div sidePanelContent class="poolPoints-side-panel largeSidepanelWidth ">
            <ng-container *ngIf="editPoolPointsVal === 'editPoolPointsVal_1'">
                <div class="editPoolPointsVal_1">
                    <div class="currentPool">
                        <p class="body-b1">Current pool points</p>
                        <p class="section-title fleet-section-title currentPool-value">{{poolPointDetails?.currentPoolPoint | negativeToBracket}}</p>
                    </div>
                    <ng-container *ngIf="poolPointDetails?.hasPreviousChange">
                        <div class="effective-date datePickerPoolPoints" *ngIf="poolPointsEffectiveDate as effectiveDate">
                            <snl-date-picker-dropdown datePickerType="date"
                            (selectedDate)="selectedPoolPointsDate($event)"
                            [min]="minSelectableDate"
                            [startMonthDate]="effectiveDate"
                            [setDefaultDate]="false"
                            title="Effective date of change"></snl-date-picker-dropdown>
                        </div>
                        <div class="multi-input editPoolPointsVal_1ReasonInput">
                            <snl-multi-line-input 
                                [label]="'Reason for change'" 
                                [maxLength]="maxLength"
                                [value]="poolPointsReason"
                                [isError]="isTextError"
                                (fieldValue)="poolPointsfieldValue($event)">
                            </snl-multi-line-input>
                        </div>
                    </ng-container>
                    <div class="change-pool-points">
                        <p class="section-title color-primaryDefault" (click)="changePoolPoints()">Change pool points</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="editPoolPointsVal === 'editPoolPointsVal_2'">
                <div class="editPoolPointsVal_2">
                    <form [formGroup]="newPoolPointForm" class="newPoolPointForm noUpcomingPoolPointForm">
                        <div class="new-pool-input">
                            <snl-input
                              [label]="'New pool points'"
                              [helperText]="searchText"
                              [type]="'text'"
                              [isError]="isPoolPointsInputError('newPoolPoints')"
                              [errorMessage]="getPoolPointsInputErrorMessage('newPoolPoints')"
                              [value]="newPoolPointForm.value.newPoolPoints"
                              formControlName="newPoolPoints"
                              (focusout)="handleFocusOutNewPoolPoints($event)">
                            </snl-input>
                        </div>
                    </form>
                    <div class="effective-date datePickerPoolPoints">
                        <snl-date-picker-dropdown datePickerType="date"
                        (selectedDate)="selectedNewPoolPointsDate($event)"
                        [min]="minSelectableDate"
                        title="Effective date of change"></snl-date-picker-dropdown>
                    </div>
                    <div class="multi-input">
                        <snl-multi-line-input [label]="'Reason for change'" [maxLength]="maxLengths" [isError]="isTextError"
                            (fieldValue)="newPoolPointsfieldValue($event)"></snl-multi-line-input>
                    </div>
                    <div class="single-line"></div>
                    <div class="currentPool">
                        <p class="body-b1">Current pool points</p>
                        <p class="section-title fleet-section-title">{{poolPointDetails?.currentPoolPoint | negativeToBracket}}</p>
                    </div>
                    <ng-container *ngIf="poolPointDetails?.hasPreviousChange">
                        <div class="currentEffDate">
                            <p class="body-b1">Effective date of change</p>
                            <!-- <p class="section-title fleet-section-title">{{selectedPoolPointsDateVal | date:'dd MMM yyyy' }}</p> -->
                             <p class="section-title fleet-section-title">{{poolPointDetails?.currentEffectiveDate | date:'dd MMM yyyy' }}</p>
                        </div>
                        <div class="resonForChange">
                            <p class="body-b1 ">Reason for change</p>
                            <!-- <p class="section-title fleet-section-title">{{poolPointsReason}}</p> -->
                             <p class="section-title fleet-section-title">{{poolPointDetails?.currentReason}}</p>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="editPoolPointsVal === 'editPoolPointsVal_3'">
                <div class="editPoolPointsVal_3">
                    <div class="notificationWrap" *ngIf="showDiscardBanner">
                        <!-- <div class="notificationData body-b1">
                            <div>
                                <figure>
                                    <img src="assets/img/infoBlue.svg" alt="information">
                                </figure>
                            </div>
                            <div>
                                <span class="notificationData_text">To change the current details, you need 
                                to discard the upcoming change first.</span>
                            </div>
                        </div> -->
                        <div class="notificationData body-b1">
                            <div>
                                <figure>
                                    <img src="assets/img/infoBlue.svg" alt="information">
                                </figure>
                            </div>
                            <div>
                                <span class="notificationData_text">To change the current details, you need
                                    to discard the upcoming change first.</span>
                            </div>
 
                        </div>
                    </div>
                
                    <div class="currentPool notificationDataCurrentPool">
                        <p class="body-b1 ">Current pool points</p>
                        <p class="section-title fleet-section-title">{{poolPointDetails?.currentPoolPoint | negativeToBracket}}</p>
                    </div>
                    <ng-container *ngIf="poolPointDetails?.hasPreviousChange">
                        <div class="currentEffDate">
                            <p class="body-b1 ">Effective date of change</p>
                            <p class="section-title fleet-section-title">{{poolPointDetails?.currentEffectiveDate | date:'dd MMM yyyy' }}</p>
                        </div>
                        <div class="resonForChange">
                            <p class="body-b1 ">Reason for change</p>
                            <p class="section-title fleet-section-title">{{poolPointDetails?.currentReason}} </p>
                        </div>
                    </ng-container>
                    <div class="single-line"></div>

                    <div class="upcomming-change ">
                        <div class="section-title fleet-body-b3 upCommingChange">Upcoming change</div>
                        <div class="discardWrap" >
                            <figure (click)="discardPoolPoint()">
                                <img src="assets/img/delBlue.svg" alt="information">
                            </figure>                     
                            <span class="discardText section-title" (click)="discardPoolPoint()">Discard</span>
                        </div>
                    </div>
                    <form [formGroup]="newPoolPointForm" class="newPoolPointForm upcomingPoolPointForm">
                        <div class="new-pool-input">
                            <snl-input
                              [label]="'New pool points'"
                              [type]="'text'"
                              [isError]="isPoolPointsInputError('newPoolPoints')"
                              [errorMessage]="getPoolPointsInputErrorMessage('newPoolPoints')"
                              [value]="newPoolPointForm.value.newPoolPoints"
                              formControlName="newPoolPoints">
                            </snl-input>
                        </div>
                    </form>
                    <div class="effective-date datePickerUpcomingPoolPoints" *ngIf="upcomingPoolEffectiveDate as effectiveDate">
                        <snl-date-picker-dropdown datePickerType="date"
                        (selectedDate)="upComingPoolPointsDate($event)"
                        [min]="minSelectableDate"
                        [startMonthDate]="effectiveDate"
                        [setDefaultDate]="false"
                            title="Effective date of change">
                        </snl-date-picker-dropdown>
                    </div>
                    <div class="multi-input upComingReasonInput">
                        <snl-multi-line-input 
                            [label]="'Reason for change'"
                            [maxLength]="maxLengths"
                            [value]="upcomingPoolReasonValue"
                            [isError]="isTextError"
                            (fieldValue)="upComingfieldValue($event)">
                        </snl-multi-line-input>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="editPoolPointsVal === 'editPoolPointsVal_4' && openEditPoolPoints">
                <div class="editPoolPointsVal_4">
                    <div class="notificationWrap">
                        <!-- <span class="notificationData body-b1">
                            <figure>
                                <img src="assets/img/infoBlue.svg" alt="information">
                            </figure>
                            <span class="notificationData_text">
                                You can modify the details until <span class="dateScrubber body-b1 fw-700">{{poolPointDetails?.nextCalculationDate | date: 'dd MMM yyyy'}}</span>  without affecting distrubtion.
                            </span>
                        </span> -->
                         <div class="notificationData body-b1">
                            <div>
                                <figure>
                                    <img src="assets/img/infoBlue.svg" alt="information">
                                </figure>
                            </div>
                            <div>
                                <span class="notificationData_text">You can modify the details until <span class="dateScrubber body-b1 fw-700">{{poolPointDetails?.nextCalculationDate | date: 'dd MMM yyyy'}}</span>  without affecting distrubtion.</span>
                            </div>
 
                        </div>
                    </div>
                    <form [formGroup]="newPoolPointForm" class="pendingPoolPointForm">
                        <div class="new-pool-input">
                            <snl-input
                              [label]="'Current pool points'"
                              [type]="'text'"
                              [isError]="isPoolPointsInputError('pendingCalcPoolPoints')"
                              [errorMessage]="getPoolPointsInputErrorMessage('pendingCalcPoolPoints')"
                              [value]="newPoolPointForm.value.pendingCalcPoolPoints"
                              formControlName="pendingCalcPoolPoints"
                              (focusout)="handleFocusOutPoolPointsPending($event)">
                            </snl-input>
                        </div>
                    </form>
                    <ng-container *ngIf="poolPointDetails?.hasPreviousChange">  
                        <div class="effective-date datePickerPoolPoints" *ngIf="pendingPoolEffectiveDate as effectiveDate">
                            <snl-date-picker-dropdown datePickerType="date"
                                [min]="minSelectableDate"
                                [startMonthDate]="effectiveDate"
                                [setDefaultDate]="false"
                                (selectedDate)="selectedPendingPoolPointsDate($event)"
                                title="Effective date of change">
                            </snl-date-picker-dropdown>
                        </div>
                        <div class="multi-input">
                            <snl-multi-line-input 
                                [label]="'Reason for change'" 
                                [maxLength]="maxLengths"
                                [value]="pendingCalcReason"
                                [isError]="isTextError"
                                (fieldValue)="pendingfieldValue($event)">
                            </snl-multi-line-input>
                        </div>
                    </ng-container>
                    <div class="single-line"></div>
                    <div class="currentPool previousPool">
                        <p class="body-b1 previousPoolPointText">Previous pool points</p>
                        <span class="wrapRestore" (click)="revertPoolPoints()">
                            <figure>
                                <img src="assets/img/arrowLeftIcon.svg" alt="arrowLeftIcon">
                            </figure>     
                            <span class="restoreText section-title fw-700">Restore previous</span>  
                        </span>
                        <p class="section-title fleet-section-title">{{poolPointDetails?.previousPoolPoint | negativeToBracket}}</p>
                    </div>
                    <div class="currentEffDate">
                        <p class="body-b1">Effective date of change</p>
                        <p class="section-title fleet-section-title">{{poolPointDetails?.previousEffectiveDate  | date:'dd MMM yyyy'}}</p>
                    </div>
                    <div class="resonForChange">
                        <p class="body-b1">Reason for change</p>
                        <p class="section-title fleet-section-title">{{poolPointDetails?.previousReason}}</p>
                    </div>
                </div>
                   
            </ng-container>
        </div>
        <div sidePanelFooterContent>
           
            <ng-container *ngIf="poolPointDetails?.hasPreviousChange">
                <snl-button   *ngIf="poolPointDetails?.status === 'pendingCalculation'" type="primary" size="large"
                    (click)="openEditPoolPoints = false;updatePoolPoints()"
                    [disabled]="pendingCalcReasonError || !pendingCalcReason || !pendingCalcDate || !pendingCalcPoolPointVal?.pendingCalcPoolPoints">
                    Save and update
                </snl-button> 
                <snl-button  *ngIf="poolPointDetails?.status === 'noChange'" type="primary" size="large" (click)="openEditPoolPoints = false;updatePoolPoints()" 
                    [disabled]="
                    !newPoolPointVal?.newPoolPoints || 
                    !selectedNewPoolPointsDateVal ||
                    !poolPointsNewReason || 
                    poolPointsNewReasonError ">
                    Save and update
                </snl-button>  
                <snl-button  *ngIf="poolPointDetails?.status === 'upcomingChange'" type="primary" size="large" (click)="openEditPoolPoints = false;updatePoolPoints()" 
                    [disabled]="!newPoolPointVal?.newPoolPoints || 
                    !upcomingPoolEffectiveDate ||
                    !upcomingPoolReasonValue || 
                    poolPointsNewReasonError"><!--  || !discardSuccess -->
                    Save and update
                </snl-button>
            </ng-container>
            <ng-container *ngIf="!poolPointDetails?.hasPreviousChange">
                <snl-button class="pending"  type="primary" size="large" (click)="openEditPoolPoints = false;updatePoolPoints()" 
                    [disabled]="!newPoolPointVal?.newPoolPoints ||
                    !selectedNewPoolPointsDateVal ||
                    !poolPointsNewReason ||
                    poolPointsNewReasonError">
                    Save and update
                </snl-button>               
            </ng-container>            
            <snl-button type="secondary" size="large" (click)="openEditPoolPoints = false;closeSidePanel()">Cancel</snl-button>
        </div>
    </snl-side-panel>
</div>

<!-- ---discard pool point -->

<snl-modal (click)="openDiscardPoolPoint = false" [type]="'small'" [open]="openDiscardPoolPoint">
  <div slot="heading" class="ppLargeModalHeading"> Discard upcoming change </div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="body-b1 color__primary">
            You are about to cancel the scheduled pool points change, effective from 
            <span class="section-title">
                {{poolPointDetails?.upcomingEffectiveDate | date:'dd MMM yyyy'}}.
            </span>
            <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="primary" size="large" (click)="openDiscardPoolPoint = false;discardPoolPointChanges()">Discard</snl-button>
      <snl-button type="secondary" size="large" (click)="openDiscardPoolPoint = false;cancelPoolPoint()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>


<!-- -----restore pool point---- -->
 <snl-modal (click)="openRestorePoolPoint = false" [type]="'small'" [open]="openRestorePoolPoint">
  <div slot="heading" class="ppLargeModalHeading"> Restore previous pool point </div>
  <div slot="modalContent" class="modal-content">
    <div class="textWrap">
        <div class="color__primary body-b1">
           You are about to change the current pool points back to the previous configuration. 
           <span class="yesProceedTxt">Are you sure you want to proceed?</span>
        </div>       
    </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="primary" size="large" (click)="openRestorePoolPoint = false;revertPoolPointsChanges();">Restore</snl-button>
      <snl-button type="secondary" size="large" (click)="openRestorePoolPoint = false;cancelPoolPoint()">Cancel</snl-button>
    </div>
  </div>
</snl-modal>